export async function asyncRetry(fn: () => unknown, numRetries: number) {
  let error;
  for (let attempt = 0; attempt < numRetries - 1; attempt++) {
    try {
      return await fn();
    } catch (e) {
      error = e;
    }
  }
  throw error;
}
